import { render } from "./ProjectDetail.vue?vue&type=template&id=387427c8&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=387427c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387427c8"]])

export default __exports__